// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SurveySessionValueModel {
    static getAttributeTypeMap() {
        return SurveySessionValueModel.attributeTypeMap;
    }
}
SurveySessionValueModel.discriminator = undefined;
SurveySessionValueModel.additionalProperties = false;
SurveySessionValueModel.attributeTypeMap = [
    {
        "name": "surveySessionId",
        "baseName": "surveySessionId",
        "type": "number"
    },
    {
        "name": "questionId",
        "baseName": "questionId",
        "type": "number"
    },
    {
        "name": "answerId",
        "baseName": "answerId",
        "type": "number"
    },
    {
        "name": "answerValue",
        "baseName": "answerValue",
        "type": "string"
    },
];
//# sourceMappingURL=surveySessionValueModel.js.map